  import { Navigate } from "react-router-dom";
  import { useDispatch, useSelector } from "react-redux";
  import type { AppDispatch, RootState } from "../stores";
  import React, { useEffect, useState } from "react";
  import { CircularProgress, Box } from "@mui/material";
  import { getAuthenticatedUser } from "../features/auth-module/authAction";

  interface ProtectedRoutesProps {
    children: React.ReactNode;
    allowedRoles: string[];
  }

  const ProtectedRoutes = ({
    children,
    allowedRoles,
  }: ProtectedRoutesProps): React.JSX.Element => {
    const dispatch = useDispatch<AppDispatch>();
    const { isAuthenticated, user } = useSelector(
      (state: RootState) => state.auth
    );
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
      const token = localStorage.getItem("token");
      const userData = localStorage.getItem("user");
      const hasAuthData = token !== null && userData !== null;

      if (hasAuthData && !isAuthenticated) {
        dispatch(getAuthenticatedUser() as any)
          .unwrap()
          .catch((error: unknown) => {
            // If getAuthenticatedUser fails (token expired/invalid), 
            // the authSlice will already set isAuthenticated to false
            // and clear tokens. We just need to ensure initialization completes.
            console.error("Failed to authenticate user:", error);
          })
          .finally(() => {
            setIsInitialized(true);
          });
      } else {
        setIsInitialized(true);
      }
    }, [isAuthenticated, dispatch]);

    if (!isInitialized) {
      return (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="100vh"
        >
          <CircularProgress />
        </Box>
      );
    }

    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }

    const userRole = user?.role?.toLowerCase();
    if (!userRole || !allowedRoles.includes(userRole)) {
      return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
  };

  export default ProtectedRoutes;
